<button type="button" class="transparent-btn" (click)="actionModal.openModal()">
  <ng-content select="[trigger]" />
</button>

<app-action-modal
  #actionModal
  [disabled]="submitted"
  submitButtonClass="lty-btn-primary"
  (submitted)="updatePolicyStatus()"
>
  <ng-container mainTitle i18n>{{ titleText }}</ng-container>
  <ng-container submitButtonLabel i18n>Confirmer</ng-container>
</app-action-modal>
